import { format } from 'date-fns'
import { stringify } from 'qs'

import { ReportFilterFormFields, reportFilterFormSchema, ReportSupportedFilters } from './types'

export const FILTERS_STORAGE_KEY = 'report_shared_filters'

export const defaultFilter: ReportFilterFormFields = {
  dateRange: {},
  sources: '',
  assets: [],
  sourceTags: [],
  multipleSources: [],
  version: undefined,
  transactionId: '',
}

export const formatDateUtcString = (date: Date) => format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")

export const getInitialQueryString = (
  initialFilters?: Partial<ReportFilterFormFields>,
  allowedFilters: ReportSupportedFilters[] = []
) => {
  let validatedReportFilters: Partial<ReportFilterFormFields> = {}

  const sessionFilters = sessionStorage.getItem(FILTERS_STORAGE_KEY)

  if (sessionFilters) {
    try {
      const parsed = JSON.parse(sessionFilters)
      validatedReportFilters = reportFilterFormSchema.parse(parsed)
    } catch {
      validatedReportFilters = {}
    }
  }

  const combinedFilters: Partial<ReportFilterFormFields> = {
    ...defaultFilter,
    ...validatedReportFilters,
    ...initialFilters,
  }

  const filtered = Object.fromEntries(
    Object.entries(combinedFilters).filter(([key]) =>
      allowedFilters.includes(key as ReportSupportedFilters)
    )
  )

  return stringify(filtered, { encode: true })
}
